import React, { useEffect, useState } from "react";

import classnames from "classnames";
import { useFormikContext } from "formik";

import { Label, Switch, Tooltip } from "clearsense-ui/components";
import { Input, Textarea, DatePicker } from "clearsense-ui/components/formik";

const Fields = ({ fields, isViewMode }) => {
  const [isTooltipDisabled, setIsTooltipDisabled] = useState();
  const { values, initialValues, errors, setFieldValue } = useFormikContext();

  let isValueDisabled;

  useEffect(() => {
    setIsTooltipDisabled(!isValueDisabled);
  });

  const getValue = (fieldName, values) => {
    const field = fieldName.split(".");
    isValueDisabled =
      !values?.[field?.[0]]?.length ||
      !values?.[field?.[0]]?.filter(item => !item.hidden)?.length;
    return values[field?.[0]]?.[field?.[1]]?.[field?.[2]];
  };

  const getField = field => {
    const { type, name } = field;
    switch (type) {
      case "text":
        return (
          <Input
            name={name}
            value={getValue(name, values) ?? ""}
            disabled={isValueDisabled || isViewMode}
          />
        );
      case "textarea":
        return (
          <Textarea
            name={name}
            value={getValue(name, values) ?? ""}
            disabled={isValueDisabled || isViewMode}
          />
        );
      case "date":
        return (
          <DatePicker
            name={name}
            size="large"
            dateFormat="YYYY-MM-DD"
            value={getValue(name, values) ?? ""}
            disabled={isValueDisabled || isViewMode}
          />
        );
      case "switch":
        return (
          <Switch
            name={name}
            checked={getValue(name, values) === "Y"}
            disabled={isValueDisabled || isViewMode}
            error={errors?.[name]}
            onChange={e => setFieldValue(name, e.target.checked ? "Y" : "N")}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {fields?.map(field => (
        <div
          key={field.name}
          className="flex space-x-2 items-center justify-start"
        >
          <Label
            className={classnames("w-80 leading-5", {
              "text-yellow-600":
                getValue(field.name, values) !==
                  getValue(field.name, initialValues) ||
                (getValue(field.name, values) === undefined &&
                  !isValueDisabled),
            })}
          >
            {field.label}
          </Label>
          <div className="flex w-full">
            <Tooltip
              disabled={isTooltipDisabled}
              content="No record found"
              position="top"
            >
              <div
                className={classnames({ "w-full": field.type !== "switch" })}
              >
                {getField(field)}
              </div>
            </Tooltip>
          </div>
        </div>
      ))}
    </>
  );
};

export default Fields;
